import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
export function FinalClose({
  onCta
}: {
  onCta: () => void;
}) {
  const megapack = PRICING_OPTIONS[0];
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-64" data-mp="2j8ipbhfelbbf">
      <div className="mx-auto max-w-2xl text-center" data-id="element-65" data-mp="2o6btk4x5bv92">
        <Reveal data-id="element-66" data-mp="2o7valxqmmabw">
          <SectionBadge tone="dark" data-id="element-67" data-mp="2t4dc8oqntsk0">Última decisión</SectionBadge>
          <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-68" data-mp="2t2slla7gutrf">
            El próximo domingo, <span className="u-lime" data-id="element-69" data-mp="2x4e2d6n4fs6w">¿qué elegís?</span>
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-7" data-id="element-70" data-mp="324iigvk4akwl">
          <div className="grid gap-3 text-left sm:grid-cols-2" data-id="element-71" data-mp="12sphyoy4exf4">
            <div className="rounded-2xl border border-white/12 bg-ink/80 p-4" data-id="element-72" data-mp="12uk60c4ov5nf">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-snow-dim" data-id="element-73" data-mp="17rj0ivs9lem5">Opción A</p>
              <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-74" data-mp="1tlawksszrdxp">
                Seguir buscando música y ejercicios a último momento, otra semana más.
              </p>
            </div>
            <div className="rounded-2xl border-2 border-lime bg-rose-deep p-4" data-id="element-75" data-mp="1kos5lm4bm03r">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-lime" data-id="element-76" data-mp="1ftctaylyoc9g">Opción B</p>
              <p className="mt-1.5 text-sm font-semibold leading-relaxed text-snow" data-id="element-77" data-mp="2ch9bu90ylhnb">
                Abrir tu Megapack y tener <span className="u-lime" data-id="element-78" data-mp="28ecltx93aj9c">todo el año resuelto</span> en minutos.
              </p>
            </div>
          </div>
        </Reveal>

        {megapack && <Reveal delay={140} className="mt-7" data-id="element-79" data-mp="1yhhtxx7bnh41">
            <p className="font-display text-4xl leading-none text-snow sm:text-5xl" data-id="element-80" data-mp="s27acakq53ux">
              {megapack.price}{' '}
              <span className="font-sans text-sm font-bold text-snow-muted" data-id="element-81" data-mp="n2ure0wz4gxm">{PRICING.currency}</span>
            </p>
            <p className="mt-1.5 text-sm font-semibold text-snow-muted" data-id="element-82" data-mp="olcjf0bz62wm">6 tomos + 5 bonos · acceso inmediato</p>

            <CtaButton variant="lime" className="mt-6 w-full max-w-sm" onClick={onCta} data-id="element-83" data-mp="tiumia3b9nwp">
              Quiero mi Megapack ahora <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-84" data-mp="fjbsel7c4d3e" />
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-snow-dim" data-id="element-85" data-mp="kgv4begk8ds6">Garantía de 7 días · Pago 100% seguro</p>
          </Reveal>}
      </div>
    </section>;
}